  <!-- 资金流水账 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" @EnterClick="queryBtn_ok" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @selectChange="handleSelectionChange" @rowCallback="rowCallback" />

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" @EnterClick="queryBtn_ok" :More="true">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "资金流水账列表", //导出时默认文件名
        apiName: "/admin/v3/finance/assetaccount/journalAccountList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "来源单号",
          field: "financeDocumentNumbers",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "单据类型",
          field: "financeDocumentStatusName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "收支类型",
          field: "inoutType",
          placeholder: "请选择",
          selectOptions: [
            {
              label: "收入",
              val: 0,
            },
            {
              label: "支出",
              val: 1,
            },
          ],
        },
        {
          // label: "资金账号",
          // type: "selectloadmore",
          // field: "fundAccountNumber",
          // loadmoreMethod: "loadDrivers",
          // remotemethod: "remoteDrivers",
          // loading: false,
          // setLabel: "account",
          // setValue: "account",
          // placeholder: "输入司机姓名进行匹配",
          // selectOptions: [],

          type: "select",
          label: "资金账号",
          field: "fundAccountNumber",
          placeholder: "请选择",
          setLabel: "account",
          setValue: "account",
          selectOptions: [],
        },
        {
          type: "select",
          label: "对账状态",
          field: "reconciliationType",
          placeholder: "请选择",
          selectOptions: [
            {
              label: "未对账",
              val: 0,
            },
            {
              label: "已对账",
              val: 1,
            },
          ],
        },
      ],

      queryData: {
        financeDocumentNumbers: null,
        financeDocumentStatusName: null,
        fundAccountNumber: null,
        inoutType: null,
        reconciliationType: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "CapitalDaybook", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 160,
          Buttons: [
            {
              method: "Reconciliation",
              methodName: "对账",
              permissVal: "admin:finance_assetaccount:cancelReconciliation",
            },
            {
              method: "UnReconciliation",
              methodName: "取消对账",
              permissVal: "admin:finance_assetaccount:cancelReconciliation",
            },
          ],
        },
        {
          name: "流水号",
          field: "financeFundflowNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "单据类型",
          field: "financeDocumentStatusName",
          sort: 4,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "来源单号",
          field: "financeDocumentNumber",
          sort: 5,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "收支类型",
          field: "inoutTypeName",
          sort: 5,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "资金账号名称",
          field: "fundAccountNumber",
          sort: 6,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "金额",
          field: "writeoffAmount",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "账号余额",
          field: "accountBalance",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "对账状态",
          field: "reconciliationTypeName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "收支备注",
          field: "inoutComment",
          sort: 19,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "核销备注",
          field: "writeoffComment",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "新建时间",
          field: "createTime",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "新建人",
          field: "createUserName",
          sort: 2,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "对账时间",
          field: "reconciliationTime",
          sort: 2,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "对账人",
          field: "reconciliationperUserName",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
      ],
      sortName: "资金流水账", //  排序名
      AccountPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },

  created() {
    this.GetData();
    this.GetassetaccountList();
    // this.GetBillType();
  },

  methods: {
    // 资金流水账列表
    GetData() {
      let queryData = {
        financeDocumentNumbers: [],
        financeDocumentStatusName: this.queryData.financeDocumentStatusName,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        fundAccountNumber: this.queryData.fundAccountNumber,
        inoutType: this.queryData.inoutType,
        reconciliationType: this.queryData.reconciliationType,
        createTimeStart: null,
        createTimeEnd: null,
      };
      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      if (this.queryData.financeDocumentNumbers) {
        queryData.financeDocumentNumbers.push(
          this.queryData.financeDocumentNumbers
        );
      }
      queryData.createTimeStart = startTime;
      queryData.createTimeEnd = endTime;

      this.$API.journalAccountList(queryData).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.className = res.data.result.className || "";

          this.tableConfig.tableData = result;
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---流水账列表`);
        }
      });
    },

    // 获取资金账号列表
    GetassetaccountList(e, checkedData) {
      // let query = {
      //   pageStart: this.AccountPage.pageStart,
      //   pageTotal: this.AccountPage.pageTotal,
      //   accountName: e,
      //   userId: checkedData,
      // };
      this.$API.assetaccountList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.baseConfig[4].selectOptions = result;
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },

    // 获取单据类型
    // GetBillType() {
    //   this.$TOOLS
    //     .getStatusValList("bill_tms_waybill_exception_v3.document_status")
    //     .then((res) => {
    //       this.baseConfig[2].selectOptions = res;
    //     });
    // },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },

    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },

    // 对账
    Reconciliation(data, msg) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        let _message = "确认把所选数据标记为已对账？";
        if (msg) {
          _message = msg;
        }
        this.$confirm(_message, "提示:")
          .then((res) => {
            let cancelReq = {
              financeFundflowId: this.selectTableData[0].financeFundflowId,
              reconciliationType: 1,
            };
            if (msg) {
              cancelReq.reconciliationType = 0;
            }
            this.$API.cancelReconciliation(cancelReq).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.GetData();
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },

    // 取消对账
    UnReconciliation(data) {
      this.Reconciliation(data, "确认把所选数据取消对账");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
  },
};
</script>
  <style scoped lang="less">
</style>
  